import {
  getExpenseCategoriesGuessed,
  GetExpenseCategoriesGuessedResponse,
} from 'api/v2/expenses';
import { useMemo, useState } from 'react';
import useQuery from 'hooks/react-query/useQuery';
import { UseQueryResult } from '@tanstack/react-query';
import { ExpensesCacheKeys } from 'types/cacheKeys.types';
import { FIVE_MINUTES } from 'utils/time';

type UseGuessExpenseCategoryWithAIProps = {
  filePath?: string;
  supplierName?: string;
  transactions?: string[];
};

export type UseGuessExpenseCategoryWithAIReturn = {
  showGuessedCategories: boolean;
  setShowGuessedCategories: (value: boolean) => void;
  enabled: boolean;
  query: UseQueryResult<GetExpenseCategoriesGuessedResponse[]>;
};

const useGuessExpenseCategoryWithAI = ({
  filePath,
  supplierName,
  transactions,
}: UseGuessExpenseCategoryWithAIProps): UseGuessExpenseCategoryWithAIReturn => {
  const filename = useMemo(() => filePath?.split('/').pop(), [filePath]);
  const [showGuessedCategories, setShowGuessedCategories] = useState(false);

  const query = useQuery(
    [
      ExpensesCacheKeys.ExpensesCategoriesGuessed,
      filename,
      supplierName,
      ...(transactions || []),
    ],
    () =>
      getExpenseCategoriesGuessed({
        filename,
        supplierName,
        transactions,
      }),
    {
      enabled: showGuessedCategories,
      gcTime: FIVE_MINUTES,
      staleTime: FIVE_MINUTES,
    },
  );

  return {
    query,
    enabled: !!filename,
    showGuessedCategories,
    setShowGuessedCategories,
  };
};

export default useGuessExpenseCategoryWithAI;
